/**
 * Andre Garen - Bulten penceresi.
 * Tetikleme: %40 scroll VEYA 25s (once gelen). Ilk sayfa goruntulemede DEGIL -
 * sayfa goruntuleme sayaci ag-mode-boot'ta (sessionStorage: ag:pageviews) tutulur,
 * yalnizca 2. goruntulemeden itibaren tetiklenir. Kapatilirsa 30 gun localStorage'da
 * hatirlanir. Basarili kayittan sonra "Tesekkurler..." 3 saniye gosterilip otomatik kapanir.
 */
(function () {
  'use strict';

  var popup = document.querySelector('[data-ag-invite]');
  if (!popup) return;

  var success = popup.querySelector('[data-ag-invite-success]');
  /* Tur 23 EK3E: basari yalniz bu form gonderildiyse (Shopify yonlendirme kancasi #AgInviteForm). Baska bir 'customer'
     formundan (footer bulteni, beden haber-ver) donuste kutu atilir - pencere zorla acilmaz, 30 gun susturulmaz. */
  if (success && location.hash !== '#AgInviteForm') { success.parentNode.removeChild(success); success = null; }
  var DISMISS_KEY = 'ag_invite_dismissed_until';
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  function isDismissed() {
    try {
      var until = parseInt(localStorage.getItem(DISMISS_KEY), 10);
      return !isNaN(until) && Date.now() < until;
    } catch (e) { return false; }
  }

  function dismissFor30Days() {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + THIRTY_DAYS_MS)); } catch (e) {}
  }

  function close() {
    popup.removeAttribute('data-open');
    setTimeout(function () { popup.hidden = true; }, 400);
  }

  // Basarili kayittan sonraki sayfa yenilemesinde: goster, 3s sonra kendiliginden kapan.
  if (success) {
    success.hidden = false;
    Array.prototype.forEach.call(popup.querySelectorAll('[data-ag-invite-alan]'), function (e) { e.hidden = true; });
    dismissFor30Days();
    popup.hidden = false;
    requestAnimationFrame(function () { popup.setAttribute('data-open', '1'); });
    setTimeout(close, 3000);
    return;
  }

  /* Tur 23 EK3F (Yigit karari): footer bulteninden basarili donus (kanca #AgFooterNewsletterForm + footer onay kutusu
     basilmis = form.posted_successfully?) - kisi listeye girdi: pencere bu sayfada hic tetiklenmez, 30 gun susturulur. */
  if (location.hash === '#AgFooterNewsletterForm' && document.querySelector('#AgFooterNewsletterForm [data-ag-nl-ok]')) {
    dismissFor30Days();
    return;
  }

  if (isDismissed()) return;

  var pageviews = 0;
  try { pageviews = parseInt(sessionStorage.getItem('ag:pageviews'), 10) || 0; } catch (e) {}
  if (pageviews < 2) return;

  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    popup.hidden = false;
    requestAnimationFrame(function () { popup.setAttribute('data-open', '1'); });
  }

  function armTriggers() {
    var timer = setTimeout(show, 25000);
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      if (p > 0.4) {
        show();
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Tur 7 EK 3: giris kapisi artik overlay degil - ag:gate-done beklenmez (kural ayni: 2. goruntuleme + 25 sn / %40).
  armTriggers();

  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-ag-invite-dismiss]')) {
      dismissFor30Days();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.getAttribute('data-open') === '1') {
      dismissFor30Days();
      close();
    }
  });
})();
